import { render, staticRenderFns } from "./CreateSentenceForm.vue?vue&type=template&id=861dca76&"
import script from "./CreateSentenceForm.vue?vue&type=script&lang=js&"
export * from "./CreateSentenceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports